import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import DispatchPageContent from './dispatch-page.content';
import useQueryParams from '../../hooks/use-query-params.hook';
import { useParamsContext } from '../../params/params-context';
import { PORTAL_TYPE } from '../../types/app.types';

const DispatchPage: React.FunctionComponent = () => {
  const {
    goToForm,
    question,
    removeParam,
    checkRedirectedFromClients
  } = useQueryParams();
  const { portalType } = useParamsContext();
  const history = useHistory();

  useEffect(() => {
    if (goToForm || question) {
      let redirectPath: string;
      switch (portalType) {
        case PORTAL_TYPE.ERDE:
          if (question) {
            redirectPath = '/erde-contact-form';
          } else {
            redirectPath = '/merchants';
          }
          break;
        case PORTAL_TYPE.ER1:
          redirectPath = '/er1-contact-form';
          break;
        case PORTAL_TYPE.UMER:
          redirectPath = '/cardholders';
          break;
        case PORTAL_TYPE.FMER:
          redirectPath = '/fmer-contact-form';
          break;
        case PORTAL_TYPE.EBUSER:
          redirectPath = '/eb-user-contact-form';
          break;
        case PORTAL_TYPE.EBCLIENT:
          redirectPath = '/eb-client-contact-form';
          break;
        default:
          redirectPath = '/';
          break;
      }
      removeParam('go_to_form');
      history.replace(redirectPath);
    }

    checkRedirectedFromClients();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <DispatchPageContent />;
};

export default DispatchPage;
